export enum FavoriteType {
  SAMPLE = "SAMPLE",
  ALBUM = "ALBUM",
  FRAGMENT = "FRAGMENT"
}

export interface FavoriteItem {
  type: FavoriteType;
  id: string; // ID of the favorite item
}

export interface FavoriteInterface {
  sub: string; // userId
  favorites: FavoriteItem[];
}
